import React, { useEffect, useState } from "react";
import { Accordion } from "react-bootstrap";
import { ResponseFormating } from "../../Functions/ResponseFormate";
import Loader from "../LoaderComponent/Loader";
import { ClearRadioGroupContext } from "@arco-design/web-react/es/Radio";


function ExtractDataExpandable({ responseData, selectedMenu, selectedSide, aofRefId, showAofDetails, aofResponse }) {
  const [formatedResponse, setFormatedResponse] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResult, setSearchResult] = useState(false);
  const [searchMatched, setSearchMatched] = useState(false);
  const [isLoader, setisLoader] = useState(false);
  const [refId, setrefId] = useState(aofRefId)


  useEffect(() => {
    handleResponse();
  }, [responseData]);


  const handleResponse = async () => {
    try {
      let data;
      let parsedResult;
      try {
        let parses = responseData.message
          ? responseData.message
          : responseData.result;
        if (responseData.message) {
          parsedResult = JSON.parse(parses);
        } else {
          parsedResult = JSON.parse(parses).message;
        }
        if (typeof parsedResult == "string") {
          parsedResult = JSON.parse(parsedResult);
        }
        data = parsedResult;
      } catch (error) {
        data = null;
      }
      let resultData = await ResponseFormating(
        selectedMenu,
        data,
        selectedSide
      );
      setFormatedResponse(resultData);
      console.log("RES--->", resultData);


      // Reset search states
      setSearchResult(false);
      setSearchMatched(false);
    } catch (err) {
      // Handle error
    }
  };


  const handleSearchInputChange = (e) => {
    setSearchTerm(e.target.value);
  };

  useEffect(()=>{
   
if(aofResponse) dataSetter()
  },[aofResponse])


const dataSetter= async () =>{
  try {
    console.log(aofResponse)
    const { message } = aofResponse?.response_data
    if(message){
      let parsed = JSON.parse(message)
      console.log(parsed)
      let data = parsed?.json
     
      let resultData = await ResponseFormating(
        selectedMenu,
        data,
        selectedSide
      );
       
      setFormatedResponse(resultData);


    }
  } catch (error) {
console.log("error ->",error);
  }
}


  const handleSearchClick = async () => {
    try {
     
      setSearchMatched(searchTerm.trim() === refId);
      setSearchResult(searchTerm.trim() === refId);
     
      if(searchResult){
       setisLoader(true)
       await showAofDetails(searchTerm)
       setisLoader(false)
      }
     
   
    } catch (error) {
     console.log(error)
    }
  };
 
  return (
    <>
    {isLoader &&<Loader></Loader>}
    <div className="extracted_data_section pb-3 overflow-auto scrollbar1 px-0 px-md-3 px-md-0 position-relative">
      <div className="pt-3 pt-md-0">
        <h2 className="font_16  fw-bold mb-3 text-center pt-2 mb-2">
          Validation
        </h2>
      </div>
      <div className="d-flex mb-3">
        <input
          type="text"
          placeholder="Search..."
          className="form-control me-2"
          value={searchTerm}
          onChange={handleSearchInputChange}
        />
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleSearchClick}
        >
          Search
        </button>
      </div>
      <div>
        <h4 style={{fontSize: 15}}> Your ID : {refId}</h4>
      </div>
      {searchResult && (
        <div>
          {formatedResponse?.data?.map((itm, index) => (
            <Accordion key={index} defaultActiveKey={0}>
              <Accordion.Item eventKey={index}>
                <Accordion.Header>{itm?.key}</Accordion.Header>
                <Accordion.Body>
                  <ul>
                    {itm?.value?.map((value, idx) => (
                      <li key={idx}>{value}</li>
                    ))}
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          ))}
      </div>
      )}
    </div>
   
    </>
  );
}


export default ExtractDataExpandable;